import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { render } from "preact";
import { useContext, useEffect } from "preact/hooks";
import { store } from "./store";
import { Tasks } from "./TaskList";
import { Scheduler } from "./Scheduler";
import { Messages } from "./Messages";
import { CombinedLayout, Nav } from "./CombinedLayout";
import Router, { Route } from "preact-router";
import { CurrentGroup, ExperimentObserver, getGroup, getParticipantId, Observer, } from "./experiment";
import { tasksById } from "./data";
import { DocumentsView } from "./Documents";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { useAppDispatch } from "./hooks";
import { markComplete } from "./tasksSlice";
import { completeCurrentTaskMaybe } from "./currentTaskSlice";
const Home = () => {
    const group = useContext(CurrentGroup);
    // In the case of control, this is a nav that opens new tabs.
    // In the case of experiment group, this is a task list.
    switch (group) {
        case "control":
            return (_jsx(Nav, { group: group, items: initialNavItems, footer: _jsx(Participant, {}) }));
        case "experiment":
            return _jsx(Tasks, {});
    }
};
const Participant = () => {
    const observer = useContext(Observer);
    return _jsxs("p", { children: ["id ", observer.participant % 10000] });
};
const LayoutDispatch = (props) => {
    const group = useContext(CurrentGroup);
    const observer = useContext(Observer);
    useEffect(() => {
        document.title = props.title ?? "";
        observer.observe({ type: "navigate", page: props.path ?? "/" });
    }, [props.title]);
    const nav = (_jsx(Nav, { group: group, items: initialNavItems, footer: _jsx(Participant, {}) }));
    switch (group) {
        case "control":
            return _jsx(_Fragment, { children: props.children });
        case "experiment":
            return _jsx(CombinedLayout, { nav: nav, main: props.children });
    }
};
function completeTaskForSchedule(dispatch, observer, date, time) {
    // XXX: this completes *any* tasks regardless of if they are visible
    const taskProps = Object.entries(tasksById).find(([_k, v]) => v.completedOn?.type === "scheduleEventAt" &&
        v.completedOn?.date === date &&
        v.completedOn?.time === time);
    if (taskProps) {
        const [taskId, _taskMeta] = taskProps;
        observer.observe({ type: "complete", id: taskId, why: "scheduled" });
        dispatch(markComplete(taskId));
        dispatch(completeCurrentTaskMaybe(taskId));
    }
}
function completeTaskForMessage(dispatch, observer, id) {
    if (tasksById[id]) {
        observer.observe({ type: "complete", id, why: "message" });
        dispatch(markComplete(id));
        dispatch(completeCurrentTaskMaybe(id));
    }
}
const Routes = () => {
    const observer = useContext(Observer);
    const dispatch = useAppDispatch();
    return (_jsxs(Router, { children: [_jsx(Route, { path: "/bookings", component: LayoutDispatch, title: "Bookings", children: _jsx(Scheduler, { onComplete: (ev) => {
                        observer.observe({ type: "schedule", event: ev });
                        completeTaskForSchedule(dispatch, observer, ev.date, ev.time);
                    } }) }), _jsx(Route, { path: "/messages", title: "Messages", component: LayoutDispatch, children: _jsx(Messages, { messages: observer.selectedExperiment().messages, onReply: (id, t) => {
                        console.log("reply", id, t);
                        completeTaskForMessage(dispatch, observer, id);
                        observer.observe({
                            type: "message",
                            id,
                            content: t,
                        });
                    } }) }), _jsx(Route, { path: "/documents", title: "Documents", component: LayoutDispatch, children: _jsx(DocumentsView, { documents: observer.selectedExperiment().documents, onOpen: (title) => {
                        console.log("open doc", title);
                        observer.observe({ type: "openDoc", title });
                    } }) }), _jsx(Route, { path: "/tasks", component: Tasks }), _jsx(Route, { default: true, title: "Start", component: LayoutDispatch, children: _jsx(Home, {}) })] }));
};
const initialNavItems = [
    {
        name: "Overview",
        icon: "icons/home.svg",
        link: "/",
        onlyInGroup: "experiment",
    },
    { name: "Bookings", icon: "icons/calendar.svg", link: "/bookings" },
    { name: "Documents", icon: "icons/file.svg", link: "/documents" },
    { name: "Messages", icon: "icons/envelope.svg", link: "/messages" },
    { name: "Settings", icon: "icons/settings.svg", link: "#" },
    { name: "Profile", icon: "icons/profile.svg", link: "#" },
];
function checkReset() {
    const parsedUrl = new URL(window.location.href);
    if (parsedUrl.searchParams.get("reset") != null) {
        window.localStorage.clear();
        parsedUrl.searchParams.delete("reset");
        window.location.href = parsedUrl.toString();
    }
}
function setupKeyboard(group) {
    document.addEventListener("keydown", (ev) => {
        if ((ev.altKey || ev.ctrlKey) && ev.key === "o") {
            ev.preventDefault();
            ev.stopPropagation();
            const parsedUrl = new URL(window.location.href);
            parsedUrl.searchParams.set("g", group === "control" ? "f" : "k");
            window.location.href = parsedUrl.toString();
        }
    });
}
function setupFocus(observer) {
    window.addEventListener("focus", (ev) => {
        observer.observe({
            type: "windowFocus",
            page: window.location.pathname,
        });
    });
}
function init() {
    checkReset();
    const main = document.getElementById("main");
    const group = getGroup();
    setupKeyboard(group);
    const participant = getParticipantId();
    const persistor = persistStore(store);
    const observer = new ExperimentObserver(group, participant);
    setupFocus(observer);
    observer.observe({ type: "begin" });
    render(_jsx(Provider, { store: store, children: _jsx(PersistGate, { loading: null, persistor: persistor, children: _jsx(Observer.Provider, { value: observer, children: _jsx(CurrentGroup.Provider, { value: group, children: _jsx(Routes, {}) }) }) }) }), main);
}
init();
